import {
  type CorrectiveAction,
  ColorEnum,
  ActionStatusEnum,
} from '../types';

export type CorrectiveActionStatus = {
  label: ActionStatusEnum;
  color: ColorEnum;
};

export const getCorrectiveActionStatus = (
  ca: Pick<CorrectiveAction, 'resolved' | 'targetDate'>,
): CorrectiveActionStatus => {
  const { resolved, targetDate } = ca;

  if (resolved === 1) {
    return { label: ActionStatusEnum.Resolved, color: ColorEnum.Resolved };
  } else if (
    (resolved === 0 &&
      (!targetDate || new Date(targetDate) >= new Date())) ||
    (targetDate && new Date(targetDate) >= new Date() && !resolved)
  ) {
    return { label: ActionStatusEnum.Open, color: ColorEnum.Open };
  } else {
    return { label: ActionStatusEnum.Overdue, color: ColorEnum.Overdue };
  }
};
